<template>
	<div class='review-details'>

		<div class='row justify-content-center'>
			<div class='col-xs-12 col-lg-10'>
				<h6 class='sub-header primary-color'>{{getText('ReviewPayment')}}</h6>
			</div>
			<div class='col-xs-12 col-lg-10 invoice-review'>
				<div class='review-block'>
          <template>
            <h2 v-if="invoice_data.type.toUpperCase() === 'DEPOSIT'">{{getText('DepositDetails')}}</h2>
            <h2 v-else-if="invoice_data.type.toUpperCase()  === 'FINAL'">{{getText('FinalDetails')}}</h2>
            <h2 v-else>{{getText('InvoiceDetails')}}</h2>
          </template>
					<div class='review-row'>
						<span class='row-key'>{{getText('InvoiceId')}}:</span>
						<span>{{invoice_data.id}}</span>
					</div>
					<div class='review-row' v-if='merchant().ShowMerchantCurrency && !invoice_data.amount_payable'>
						<span class='row-key'>{{getText('InvoiceAmount')}}:</span>
						<span>{{merchant_currency().symbol}}{{(invoice_data.amount*1).toFixed(merchant_currency().units)}} {{merchant_currency().currency}}</span>
					</div>
					<div class='review-row' v-if='!merchant().ShowMerchantCurrency && !invoice_data.amount_payable'>
						<span class='row-key'>{{getText('InvoiceAmount')}}:</span>
						<span>{{rateOffer().Symbol}}{{AMOUNT_subtotal()}} {{rateOffer().Currency}}</span>
					</div>
				</div>
				<div class='review-block'>
					<h2>{{getText('PaymentDetails')}}</h2>
					<div class='card-details row' v-if='payment.Class == "Card"'>
						<div class='col-sm-9'>
							<h6>{{getText('CardNumber')}}</h6>
							<div class='card-number'>XXXX XXXX XXXX {{stash.Last4}} <img class='payment-logo' :src='"//st.rch.io/methods/"+payment.Id+".png"'></div>
						</div>
						<div class='col-sm-3 expiry'>
							<h6>{{getText('CardExpiry')}}</h6>
							<div>{{paymentInfo.Expiry.Month}} / {{paymentInfo.Expiry.Year}}</div>
						</div>
						<div class='card-name col-sm-12 broken'>
							<h6>{{getText('CardholderName')}}</h6>
							<div>{{paymentInfo.Name}}</div>
						</div>
					</div>
					<div class='card-details row' v-if='payment.Class == "Online"'>
						<div class='col-12 col-sm-6'>
							<div>
								<img class='payment-logo' :src='"//st.rch.io/methods/"+payment.Id+".png"'>
								<div class='payment-name'>{{payment.Name}}</div>
							</div>
						</div>
						<div class='col-12 col-sm-6'>
							<h6>{{getText('OnlinePayment')}}</h6>
							<div>{{redirectText(payment.Name)}}</div>
						</div>
					</div>
					<div class='card-details row' v-if='payment.Class == "Offline"'>
						<div class='col-12'>
							<div>
								<img class='payment-logo' :src='"//st.rch.io/methods/"+payment.Id+".png"'>
								<div class='payment-name'>{{payment.Name}}</div>
							</div>
						</div>
						<div class='col-12 col-sm-6' v-if='payment_issuer.length > 0'>
							<h6>{{getText('BankInstitution')}}</h6>
							<div>{{payment_issuer}}</div>
						</div>
						<div class='col-12 col-sm-6'>
							<h6>{{getText('OfflinePayment')}}</h6>
							<div>{{getText('OfflinePaymentHint')}}</div>
						</div>
					</div>
				</div>
				<div class='review-block'>
					<h2>{{getText('BillingAddress')}}</h2>
					<div class='row'>
						<div class='col-sm-12 broken'>
							<div class='review-row'>{{billing_details.Name}}</div>
							<div class='review-row'>{{billing_details.Address}}</div>
							<div class='review-row'>{{billing_details.City}}, {{billing_details.Region}} {{billing_details.PostalCode}}</div>
							<div class='review-row'>{{country_name}}</div>
						</div>
					</div>
				</div>
				<div class='review-block'>
					<h2>{{getText('OtherDetails')}}</h2>
					<div class='row'>
						<div class='col-sm-12 broken'>
							<div class='review-row' v-if='billing_details.NationalIdentifier !== null && billing_details.NationalIdentifier.length > 0'>
								<span class='row-key'>{{getText('NationalIdentifier')}}:</span>
								<span>{{billing_details.NationalIdentifier}}</span>
							</div>
							<div class='review-row' v-if='billing_details.BirthDate !== null && billing_details.BirthDate.length > 0'>
								<span class='row-key'>{{getText('BirthDate')}}:</span>
								<span>{{billing_details.BirthDate}}</span>
							</div>
							<div class='review-row'>
								<span class='row-key'>{{getText('EmailAddress')}}:</span>
								<span>{{billing_details.Email}}</span>
							</div>
							<div class='review-row'>
								<span class='row-key'>{{getText('PhoneNumber')}}:</span>
								<span>{{billing_details.Phone}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class='review-block'>
					<h2>{{getText('PaymentSummary')}}</h2>
					<div class='row'>
						<div class='col-sm-12 broken'>
							<div class='review-row' v-if='merchant_currency().currency != rateOffer().Currency && merchant().ShowMerchantCurrency'>
								<span class='row-key'>{{getText('ExchangeRate')}}:</span>
								<span>1 {{merchant_currency().currency}} = {{rateOffer().RateOffer.Rate}} {{rateOffer().Currency}}</span>
							</div>
							<div class='review-row'>
								<span class='row-key'>{{getText('Subtotal')}}:</span>
								<span>{{rateOffer().Symbol}}{{AMOUNT_subtotal()}} {{rateOffer().Currency}}</span>
							</div>
						</div>
						<div class='col-sm-12 broken' v-if='financing_selected().Number !== undefined'>
							<div class='review-row'>
								<span class='row-key'>{{getText('Instalments')}}:</span>
								<span>{{financing_selected().Number}} {{getText('Instalments')}}</span>
							</div>
							<div class='review-row'>
								<span class='row-key'>{{getText('FinancingFees')}} ({{financing_selected().Rate * 100}}%):</span>
								<span>{{rateOffer().Symbol}}{{AMOUNT_finance_fees()}} {{rateOffer().Currency}}</span>
							</div>
						</div>
						<div class='col-sm-12 broken' v-if='merchant().CollectFees && AMOUNT_processing_fees() > 0'>
							<div class='review-row'>
								<span class='row-key'>{{getText('ProcessingFees')}}:</span>
								<span>{{rateOffer().Symbol}}{{AMOUNT_processing_fees()}} {{rateOffer().Currency}}</span>
							</div>
						</div>
						<div class='col-sm-12 broken total-col primary-color'>
							<div class='review-row'>
								<span class='row-key'>{{getText('Total')}}</span>
								<span>{{rateOffer().Symbol}}{{AMOUNT_total()}} {{rateOffer().Currency}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row justify-content-center">
			<div class="col-xs-12 col-lg-8 checkbox-block">
				<div v-if='!merchant().DisableReachTerms'>
					<br/>
					<FormCheckbox style='position:absolute;' v-model='accept_terms'/>
					<div class='checkbox-info'> {{badgeText()}} <img class='logo-in-text' :src='badge().ImageUrl'/> <a :href='badge().TermsOfServiceUrl' target='_blank'>{{getText('TermsOfService')}}</a>.
						<!--I have read and agree to the <a href='https://withreach.com/terms-of-service.html' target='_blank'> Terms & Conditions</a> and <a href='https://withreach.com/privacy-policy.html' target="_blank">Privacy Policy</a>.-->
					</div>
				</div>
				<div v-if='merchant().ShowMerchantTerms'>
          <div v-if='merchant().DisableReachTerms' class='checkbox-info' style="padding-top: 5px;"> <p>{{badgeText()}} <img class='logo-in-text' :src='badge().ImageUrl'/> <a :href='badge().TermsOfServiceUrl' target='_blank'>{{getText('TermsOfService')}}</a>.</p></div>
					<br/>
					<FormCheckbox style='position:absolute;' v-model='merchant_terms'/>
					<div class='checkbox-info' v-html='merchant_terms_string'></div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import { mapGetters } from "vuex";

// Language / Localization
import LanguageService from "@/common/language.service";

import FormCheckbox from "@/components/form_elements/FormCheckbox"

export default {
	name: "ReviewScreen",
	components: {
		FormCheckbox
	},
	data(){
		return {
			terms_value: this.value,
			merchant_terms_value: false,
			stash: this.stashed(),
			payment: this.payment_method(),
			invoice_data: this.invoice(),
			billing_details: this.billing(),
			paymentInfo: this.payment_details()
		};
	},
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		merchant_terms_string(){
			if(!this.merchant().ShowMerchantTerms) return '';
			var text = this.merchant().MerchantTerms.Text;
			var link = "<a href='"+this.merchant().MerchantTerms.TermsLink+"' target='_blank'>"+this.merchant().MerchantTerms.LinkText+"</a>";
			return text.replace("{$link}", link);
		},
		// Watch accept item
		sub_total(){
			return (this.invoice_data.amount * this.rateOffer().RateOffer.Rate).toFixed(this.rateOffer().Units);
		},
		financing_cost(){
			return (this.sub_total * this.financing_selected().Rate).toFixed(this.rateOffer().Units);
		},
		pre_total(){
			// Generate the total based on financing
			var total = 0;
			if(this.financing_selected().Number === undefined || this.financing_selected().Number < 2){
				total = this.sub_total;
			} else {
				total = ((this.sub_total*1) + (this.financing_cost*1)).toFixed(this.rateOffer().Units);
			}
			return total;
		},
		processing_fee_cost(){
			// Generate fee cost using pre total (sub + financing) and fee rate
			return (this.pre_total * this.processing_rate).toFixed(this.rateOffer().Units);
		},
		processing_rate(){
			// If we don't collect fees, ignore
			if(!this.merchant().CollectFees) return 0;

			// Otherwise, continue
			var pay_id_key = "Default";
			// Try specific payment method
			if(this.fees()[this.payment.Class] !== undefined) pay_id_key = this.payment.Class;
			// Then try general method
			else if(this.fees()[this.payment.Id] !== undefined) pay_id_key = this.payment.Id;
			// Return our fee
			return this.fees()[pay_id_key];
		},
		total(){
			// Then add processing fees (now with 100% more janky js addition vs concat)
			var total = (1*this.pre_total) + (1*this.processing_fee_cost);
			// Return formatted w/ units
			return total.toFixed(this.rateOffer().Units);
		},
		accept_terms: {
			set(val){
				this.terms_value = val;
			},
			get(){
				return this.terms_value;
			}
		},
		merchant_terms: {
			set(val){
				this.merchant_terms_value = val;
			},
			get(){
				return this.merchant_terms_value;
			}
		},
		payment_issuer(){
			if(this.payment_method().Issuers === undefined || this.payment_method().Issuers.length == 0) return '';
			return this.payment_method().Issuers.filter(x => x.Id == this.issuer())[0].Name;
		},
		country_name(){
			return this.countries().filter( x => (x.code == this.billing_details.Country) )[0].name;
		}
	},
	watch: {
		accept_terms: function(){
			this.check_terms();
		},
		merchant_terms: function(){
			this.check_terms();
		}
	},
	methods: {
		check_terms(){
			var all_terms = false;
			if(this.terms_value || this.merchant().DisableReachTerms){
				// CHECK MERCHANT TERMS
				if(this.merchant().ShowMerchantTerms || this.merchant().DisableReachTerms){
					if(this.merchant_terms_value) {
						all_terms = true;
					}
				} else {
					all_terms = true;
				}
			}
			// Pass terms status back up
			this.$emit('input', all_terms);
		},
		badgeText(){
			var name = this.merchant().Merchant;
			return this.getText('BadgeText').format(name);
		},
		redirectText(name){
			return this.getText('OnlinePaymentHint').format(name);
		},
		getText(key){
			return LanguageService.getText(key);
		},
		...mapGetters([
				"rateOffer",
				"financing_selected",
				"issuer",
				"merchant",
				"merchant_currency",
				"fees",
				"static_fees",
				"badge",
				"countries",
				"invoice",
				"stashed",
				"billing",
				"payment_details",
				"payment_method",

				"AMOUNT_subtotal",
				"AMOUNT_finance_fees",
				"AMOUNT_processing_fees",
				"AMOUNT_total"

			])
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	@import "node_modules/bootstrap/scss/functions";
	@import "node_modules/bootstrap/scss/variables";
	@import "node_modules/bootstrap/scss/mixins/_breakpoints";

	.invoice-review {
		@include media-breakpoint-up(lg) {
			border: 3px solid #E2E3E3;
			padding: 30px 50px;
		}
	}
	.review-details{
		width: 100%;
	}
	.checkbox-block{
		.form-input{
			position: absolute;
		}
	}
	.logo-in-text{
		height: 16px;
		margin: -2px 0px 0px 0px;
	}
	.checkbox-info{
		/*line-height: 26px;*/
		display: inline-block;
		/*vertical-align: top;
		margin-left: 10px;*/
		padding-left: 35px;
	}
	.form-input,.input-block{
		display: inline-block;
	}
	.expiry {
		@include media-breakpoint-up(sm) {
			text-align: right;
		}
	}
	.review-block{
		color: #747C84;
		font-size: 14px;
		padding-bottom: 30px;

		@include media-breakpoint-up(lg) {
			padding-top: 30px;
			padding-left: 30px;
			padding-right: 30px;
			font-size: 20px;
		}

		.review-row{
			margin-top: 5px;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			text-align: right;


			.row-key{
				font-weight: bold;
				text-align: left;
			}
		}

		h2 {
			font-family: 'proximanova-semibold';
			font-size: 20px;
			border-bottom: 1px solid #E2E3E3;
			padding-bottom: 5px;
			margin-bottom: 20px;

			@include media-breakpoint-up(lg) {
				font-size: 28px;
				margin-bottom: 30px;
			}
		}

		.payment-logo{
			height: 40px;
		}

		.payment-name{
			display: inline-block;
			font-size: 26px;
			vertical-align: middle;
			margin-left: 10px;
			margin-top: 5px;
			text-transform: uppercase;
		}

		.card-number{
			.payment-logo{
				height: 25px;
				position: relative;
				bottom: 3px;
				left: 10px;
			}
		}

		.card-name{
			margin-top: 20px;
		}

		h6{
			margin-bottom: 5px;
		}
	}
	.total-col {
		margin-top: 30px;

		.review-row {
			border-top: 3px solid #E2E3E3 !important;
			padding-top: 20px;
		}

		span {
			font-size: 20px;
			@include media-breakpoint-up(lg) {
				font-size: 32px;
			}
		}
	}
</style>
